<template>
  <div class="mothers-registration">
    <v-container class="my-1">
      <v-card>
        <v-card-title class="page-head">
          <div class="ph-left">
            <div class="ph-icon"><v-icon color="#6a1b9a">mdi-account-heart</v-icon></div>
            <div>
              <div class="ph-title">Care Giver Registration</div>
              <div class="ph-sub">Register and manage care givers</div>
            </div>
          </div>
          <v-spacer />
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search..."
            outlined
            dense
            hide-details
            class="ph-search"
          />
          <v-btn class="ph-btn" @click="formNuevo()">
            <v-icon left small>mdi-plus</v-icon>
            New Care Giver
          </v-btn>
        </v-card-title>

        <!-- Global loading bar for slow internet / API -->
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-1"
        />

        <v-tabs v-model="tab" class="report-tabs">
          <v-tab>
            <v-icon left small>mdi-account-plus-outline</v-icon>
            New Care Givers
            <v-chip x-small class="ml-2" color="#e3f0fd" text-color="#1565c0">{{ newMothers.length }}</v-chip>
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-account-check-outline</v-icon>
            Assigned Care Givers
            <v-chip x-small class="ml-2" color="#e8f5e9" text-color="#2e7d32">{{ assignedMothers.length }}</v-chip>
          </v-tab>
        </v-tabs>

        <v-data-table
          class="elevation-0"
          :search="search"
          :headers="headers"
          :items="filteredMothers"
          item-value="idga"
          :loading="loading"
          loading-text="Loading care givers..."
          :items-per-page="-1"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1], 'items-per-page-text': 'Rows per page' }"
        >
          <template v-slot:item.index="{ index }">
            <span class="cell-muted">{{ index + 1 }}</span>
          </template>

          <template v-slot:item.motherimage="{ item }">
            <v-avatar size="38" class="avatar-ring">
              <v-img v-if="item.motherimage" :src="uploadBaseUrl + item.motherimage" />
              <v-icon v-else color="#90a4ae">mdi-account-heart</v-icon>
            </v-avatar>
          </template>

          <template v-slot:item.mothername="{ item }">
            <span class="cell-name">{{ item.mothername }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="formEditar(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit care giver</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#c62828" v-bind="attrs" v-on="on" @click="borrar(item.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete care giver</span>
            </v-tooltip>
          </template>

          <template v-slot:item.more="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#1565c0" v-bind="attrs" v-on="on" @click="show(item.id)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>View details</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="44" color="#b0bec5">mdi-account-heart-outline</v-icon>
              <div class="empty-text">{{ tab === 0 ? 'No unassigned care givers' : 'No assigned care givers' }}</div>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="diag" scrollable max-width="520px">
        <v-card v-for="more in moreinfo" :key="more.id">
          <div class="dlg-head">
            <div class="dlg-head-icon"><v-icon color="#fff">mdi-account-heart</v-icon></div>
            <div>
              <div class="dlg-title">Care Giver Details</div>
              <div class="dlg-sub">{{ more.mothername }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="diag = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <div class="d-flex justify-center pt-5 pb-2" style="gap: 48px;">
            <div class="text-center">
              <v-avatar size="80" class="avatar-ring lg">
                <v-img v-if="more.motherimage" :src="uploadBaseUrl + more.motherimage" />
                <v-icon v-else size="36" color="#90a4ae">mdi-account-heart</v-icon>
              </v-avatar>
              <div class="cell-muted mt-1">Care Giver</div>
            </div>
            <div class="text-center">
              <v-avatar size="80" class="avatar-ring lg">
                <v-img v-if="more.image" :src="uploadBaseUrl + more.image" />
                <v-icon v-else size="36" color="#90a4ae">mdi-account-tie</v-icon>
              </v-avatar>
              <div class="cell-muted mt-1">Clan Elder</div>
            </div>
          </div>
          <v-card-text style="height: 300px;">
            <v-simple-table>
              <tbody>
                <tr><th>Care Giver</th><td>{{ more.mothername }}</td></tr>
                <tr><th>Sex</th><td>{{ more.sex }}</td></tr>
                <tr><th>Clan Elder</th><td>{{ more.name }}</td></tr>
                <tr><th>Elder Phone</th><td>{{ more.phone }}</td></tr>
                <tr><th>Date of Birth</th><td>{{ more.dateofbirth }}</td></tr>
                <tr><th>Address</th><td>{{ more.address }}</td></tr>
                <tr><th>Street</th><td>{{ more.street }}</td></tr>
                <tr><th>Contact</th><td>{{ more.contact }}</td></tr>
                <tr><th>Economics</th><td>{{ more.mothereconomics }}</td></tr>
                <tr><th>Place of Birth</th><td>{{ more.placeofbirth }}</td></tr>
                <tr><th>Status</th><td>{{ more.status }}</td></tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <div class="dlg-head">
            <div class="dlg-head-icon">
              <v-icon color="#fff">{{ oper === 'Add' ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
            </div>
            <div>
              <div class="dlg-title">{{ oper === 'Add' ? 'New Care Giver' : 'Edit Care Giver' }}</div>
              <div class="dlg-sub">{{ oper === 'Add' ? 'Register a new care giver' : 'Update care giver details' }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-card-text class="pt-5">
            <v-form>
              <input type="hidden" v-model="mother.idga" />

              <div class="photo-row">
                <v-avatar size="64" class="avatar-ring lg">
                  <v-img v-if="mother.motherimage" :src="uploadBaseUrl + mother.motherimage" />
                  <v-icon v-else size="30" color="#90a4ae">mdi-account-heart</v-icon>
                </v-avatar>
                <v-file-input
                  accept="image/*"
                  label="Photo"
                  prepend-icon="mdi-camera"
                  outlined
                  dense
                  hide-details
                  show-size
                  class="photo-input"
                  @change="onFilechange"
                />
                <input type="hidden" v-model="mother.motherimage" />
              </div>

              <div class="form-section">Personal Details</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.mothername" label="Care Giver Name" outlined dense prepend-inner-icon="mdi-account-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="mother.sex" :items="['Male', 'Female']" label="Sex" outlined dense prepend-inner-icon="mdi-gender-male-female" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.dateofbirth" label="Date of Birth" type="date" outlined dense prepend-inner-icon="mdi-calendar" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.placeofbirth" label="Place of Birth" outlined dense prepend-inner-icon="mdi-map-marker-outline" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="mother.mariagestatus" :items="['Mariage', 'Single','Widowed','Divorced','Other']" label="Marriage Status" outlined dense prepend-inner-icon="mdi-heart-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.contact" label="Contact" outlined dense prepend-inner-icon="mdi-phone-outline" />
                </v-col>
              </v-row>

              <div class="form-section">Location & Clan Elder</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.address" label="Address" outlined dense prepend-inner-icon="mdi-home-outline" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.street" label="Street" outlined dense prepend-inner-icon="mdi-road-variant" />
                </v-col>
                <v-col cols="12" md="6" v-if="isAdmin">
                  <v-select
                    v-model="mother.district"
                    :items="districts"
                    item-text="district_name"
                    item-value="district_name"
                    label="District"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker-outline"
                  />
                </v-col>
                <v-col cols="12" :md="isAdmin ? 6 : 12">
                  <label class="cell-muted d-block mb-1">Clan Elder</label>
                  <Select2
                    v-model="mother.nabd_id"
                    :options="nabadoonoption"
                    id="postreg"
                    :settings="{width: '100%'}"
                    @change="changedLabel3"
                  />
                </v-col>
              </v-row>

              <div class="form-section">Household</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.mothereconomics" label="Economic Status" outlined dense prepend-inner-icon="mdi-cash-multiple" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="mother.nofamily" label="Number of Family" type="number" outlined dense prepend-inner-icon="mdi-account-multiple-outline" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dlg-actions">
            <v-spacer />
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn color="#0d2d63" dark @click="guardar()">
              <v-icon left small>mdi-content-save-outline</v-icon>
              {{ oper === 'Add' ? 'Save Care Giver' : 'Save Changes' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" bottom right :multi-line="multiLine" color="blue">
        {{ text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

// Define API URLs specific to mothers
const API_URL_MOTHERS = process.env.VUE_APP_API_URL; // New PHP script for mothers

const UPLOAD_URL_MOTHERS = process.env.VUE_APP_UPLOAD_URL; // If image upload is different
const IMAGE_BASE_MOTHERS = process.env.VUE_APP_IMAGE_BASE; // If separate image directory

export default {
  data() {
    return {
      search: '',
      tab: 0,
      mothers: [], // This will hold the list of mothers
      dialog: false,
      diag: false,
      oper: 'Add',
      operacion: '',
      snackbar: false,
      multiLine: true,
      text: '',
      loading: false,
      moreinfo: [], // For detailed mother info
      mother: { // Data model for a single mother record
        idga: null,
        mothername: '',
        sex: '',
        nabd_id: '',
        dateofbirth: '',
        address: '',
        street: '',
        contact: '',
        motherimage: '',
        mothereconomics: '',
        nofamily: '',
        mariagestatus: '',
        placeofbirth: '',
        status: '1',
        user_id: '',
        district: '',
      },
      districts: [],
      nabadoonoption:[],
      headers: [ // Headers for the Vuetify data table
        { text: 'NO', value: 'index' },
        { text: 'Image', value: 'motherimage' },
        { text: 'Care Giver', value: 'mothername' },
        { text: 'Contact', value: 'contact' },
        { text: 'Show more', value: 'more', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      uploadBaseUrl: IMAGE_BASE_MOTHERS,
      authenticated: JSON.parse(localStorage.getItem('status')),
    };
  },

  computed: {
    newMothers() {
      return this.mothers.filter((m) => Number(m.assigned) !== 1);
    },
    assignedMothers() {
      return this.mothers.filter((m) => Number(m.assigned) === 1);
    },
    filteredMothers() {
      return this.tab === 0 ? this.newMothers : this.assignedMothers;
    },
    isAdmin() {
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        const r = (u.role || localStorage.getItem('usertype') || '').toString().trim().toLowerCase();
        return r === 'admin';
      } catch (e) {
        return false;
      }
    },
  },

  mounted() {
    if (!this.authenticated) this.$router.replace({ name: 'login' });
    this.mostrar(); // Load initial mother data
    this.fetchnabadoon(); //load select2
    this.fetchDistricts();
  },

  methods: {
    changedLabel3(event) {
     this.mother.nabd_id = event;
    },
    fetchnabadoon: function(){
             axios.post(API_URL_MOTHERS,{opcion:6, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.nabadoonoption = response.data; 
                this.mother.nabd_id=this.changedLabel3;
                //console.log(this.nabadoonoption)
              });
        },
    // onFilechange for mother image upload (similar to child)
    onFilechange(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      axios
        .post(UPLOAD_URL_MOTHERS, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          this.mother.motherimage = res.data;
          this.snackbar = true;
          this.text = res.data ? 'Image uploaded!' : 'Upload failed.';
          console.log(res.data);
          setTimeout(() => (this.snackbar = false), 2000);
        })
        .catch(() => {
          this.snackbar = true;
          this.text = 'Upload error';
          setTimeout(() => (this.snackbar = false), 2000);
        });
    },

    // Form handling methods
    formNuevo() {
      this.dialog = true;
      this.operacion = 'crear';
      this.oper = 'Add';
      // Reset mother data for new entry
      this.mother = {
        idga: '',
        mothername: '',
        sex: '',
        nabd_id: '',
        dateofbirth: '',
        address: '',
        street: '',
        contact: '',
        motherimage: '',
        mothereconomics: '',
        nofamily: '',
        mariagestatus: '',
        placeofbirth: '',
        status: '',
        user_id: '',
        district: '',
      };
    },

    formEditar(item) {
      this.dialog = true;
      this.operacion = 'editar';
      this.oper = 'Update'; 
      // Copy item data to the form
      this.mother = { ...item };
      console.log(this.mother)
    },

    async guardar() {
      const ok = this.operacion === 'crear' ? await this.crear() : await this.editar();
      if (ok) this.dialog = false;
    },

    backendErrorText(res) {
      if (res && Array.isArray(res.data) && res.data[0] && res.data[0].ok === false) {
        return res.data[0].msg || 'Save failed';
      }
      return '';
    },

    showSnackbar(text) {
      this.text = text;
      this.snackbar = true;
      setTimeout(() => (this.snackbar = false), 3000);
    },

    // CRUD operations for mothers
    async crear() {
      const payload = {
        opcion: 11,
        op: 1,
        idga: this.mother.idga,
        mothername: this.mother.mothername,
        sex: this.mother.sex,
        nabd_id: this.mother.nabd_id,
        dateofbirth: this.mother.dateofbirth,
        address: this.mother.address,
        street: this.mother.street,
        contact: this.mother.contact,
        motherimage: this.mother.motherimage || 'logo.png',
        mothereconomics: this.mother.mothereconomics,
        nofamily: this.mother.nofamily,
        mariagestatus: this.mother.mariagestatus,
        placeofbirth: this.mother.placeofbirth,
        status: this.mother.status,
        district: this.mother.district,
        user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      try {
        const res = await axios.post(API_URL_MOTHERS, payload);
        const err = this.backendErrorText(res);
        if (err) {
          this.showSnackbar(err);
          return false;
        }
        this.mostrar();
        this.showSnackbar('Mother inserted successfully');
        return true;
      } catch (e) {
        this.showSnackbar('Network error. Please try again.');
        return false;
      }
    },

    async editar() {
      const payload = {
        opcion: 11,
        op: 11,
        idga: this.mother.id,
        mothername: this.mother.mothername,
        sex: this.mother.sex,
        nabd_id: this.mother.nabd_id,
        dateofbirth: this.mother.dateofbirth,
        address: this.mother.address,
        street: this.mother.street,
        contact: this.mother.contact,
        motherimage: this.mother.motherimage,
        mothereconomics: this.mother.mothereconomics,
        nofamily: this.mother.nofamily,
        mariagestatus: this.mother.mariagestatus,
        placeofbirth: this.mother.placeofbirth,
        status: this.mother.status,
        district: this.mother.district,
        user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '',
      };
      try {
        const res = await axios.post(API_URL_MOTHERS, payload);
        const err = this.backendErrorText(res);
        if (err) {
          this.showSnackbar(err);
          return false;
        }
        this.mostrar();
        this.showSnackbar('Mother updated successfully');
        return true;
      } catch (e) {
        this.showSnackbar('Network error. Please try again.');
        return false;
      }
    },

    borrar(idga) {
      axios.post(API_URL_MOTHERS, { opcion: 11, op: 12, idga: idga, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.mostrar();
        console.log(res)
        this.text = 'Mother deleted successfully';
        this.snackbar = true;
        setTimeout(() => (this.snackbar = false), 2000);
      });
    },

    show(idga) {
        console.log(idga)
      axios.post(API_URL_MOTHERS, { opcion: 11, idga: idga, op: 23, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.moreinfo = res.data;
        console.log(res.data)
        this.diag = true;
      });
    },

    mostrar() {
      this.loading = true;
      axios
        .post(API_URL_MOTHERS, { opcion: 11, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' })
        .then((res) => {
          this.mothers = res.data;
        })
        .catch(() => {
          this.text = 'Failed to load care givers. Please check your connection.';
          this.snackbar = true;
          setTimeout(() => (this.snackbar = false), 2000);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchDistricts() {
      axios.post(API_URL_MOTHERS, { opcion: 40 }).then((res) => {
        this.districts = res.data || [];
      }).catch(() => { this.districts = []; });
    },
  },
};
</script>

<style scoped>
/* You can copy the styles from your ChildRegistration.vue or define new ones */
.projects { /* Renamed to .mothers-registration or similar for clarity */
  /* Your styles here */
}
tbody td,
tbody th {
  border-left: 1px solidga silver;
}
</style>